import { AgmCoreModule } from '@agm/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AgmDirectionModule } from 'agm-direction';

@NgModule({
  imports: [
    CommonModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDpzFm0JwSmVUbSHVJxsngbxRcm9vreGcI',
      libraries: ['places']
    }),
    AgmDirectionModule,
  ],
  exports: [
    AgmCoreModule,
    AgmDirectionModule
  ]

})
export class AgmModule {

}